export const worldcountriesData = {
	title: {
		en: "Explore the World Countrie",
		zh: "探索世界各国",
		ko: "세계 국가 탐험",
	},
	sub_title: {
		en: "Discover Fascinating Details and Facts about Countries Worldwide",
		zh: "发现世界各国的有趣细节和事实",
		ko: "세계 각국에 대한 흥미로운 세부사항과 사실 발견하기",
	},
};